import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  title: {
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "45px",
    color: ({ theme }) => theme.palette.text.primary,
    justifyContent: "flex-start",
    display: "flex",
    marginBottom: "1rem",
  },
  sectionsWrapper: {
    backgroundColor: ({ theme }) => theme.palette.bgColor,
    boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    paddingInline: "10px 5px",
    fontFamily: "Rubik",
    paddingBottom: "1rem",
    display: "flex",
    justifyContent: "space-between",
    marginRight: "10px",
    marginLeft: "10px",
    flexDirection: "column",
    marginBottom: "20px",
  },
  wrapper: {
    justifyContent: "flex-start",
    display: "flex",
    width: "100%",
    marginLeft: ({ isNavbarOpen }) => isNavbarOpen ? "21%" : "12%",
  },
  actionBtn: {
    backgroundColor: ({ theme }) => theme.palette.button.primary,
    color: ({ theme }) => theme.palette.text.primary,
    border: "2px solid #A8ABC2",
    fontWeight: 700,
    "&:hover": {
      backgroundColor: "transparent",
    },
    minWidth: "35px !important",
    height: "2.1rem",
    width: "2.1rem",
  },
  actionsContainer: {
    display: "flex",
    gap: "10px",
    height: "100%",
    alignItems: "center",
    width: "60%",
  },
  tableWrapper: {
    width: "98%",
  },

  addRoleButton: {
    width: "150px",
    height: "37px",
    background: "#9A0143",
    fontFamily: "Rubik",
    fontSize: "12px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#9A0143",
    },
  },
});
